import { NUMBER_SIZE } from '../../../../constants/size'
import { useContentOverflow } from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import { FileIcon } from '../../../FileIcon'
import { FloatingTooltip } from '../../../Floating'
import { MultiValuedListMoreItem } from '../../../MultiValuedList'

import * as styles from './MoreItem.module.css'

function MoreItem({ filename, id, mime_type, onClick, ...itemProps }) {
  const file = { filename, id, mime_type }

  const { overflow, setContentOverflowRef } = useContentOverflow()

  function handleClick(e) {
    stopPropagation(e)
    onClick?.(id)
  }

  return (
    <MultiValuedListMoreItem
      {...itemProps}
      className={styles.moreItem}
      onClick={handleClick}
    >
      <FloatingTooltip content={filename} disabled={!overflow}>
        <div className={styles.item}>
          <FileIcon
            className={styles.icon}
            file={file}
            size={NUMBER_SIZE.size20}
          />
          <span className={styles.text} ref={setContentOverflowRef}>
            {filename}
          </span>
        </div>
      </FloatingTooltip>
    </MultiValuedListMoreItem>
  )
}

export default MoreItem
